import { render, staticRenderFns } from "./studentLiteracyAssessment.vue?vue&type=template&id=781d3546&scoped=true"
import script from "./studentLiteracyAssessment.vue?vue&type=script&lang=js"
export * from "./studentLiteracyAssessment.vue?vue&type=script&lang=js"
import style0 from "./studentLiteracyAssessment.vue?vue&type=style&index=0&id=781d3546&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "781d3546",
  null
  
)

export default component.exports